module.exports = __webpack_public_path__ + "img/strip-18.cd78248d.jpg";